import { methods, request } from "./base";

const deviceApis = {
  getAvailableDevices: async (data?: any) =>
    await request({
      method: methods.GET,
      route: "/gfc/devices/config",
      payload: data,
      priv: true,
    }),
  getConnectedDevices: async (data?: any) =>
    await request({
      method: methods.GET,
      route: "/gfc/devices/connected",
      payload: data,
      priv: true,
    }),
};

export default deviceApis;
